import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.freeze";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.promise";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/es.string.anchor";
import "core-js/modules/es.typed-array.int32-array";
import "core-js/modules/es.typed-array.copy-within";
import "core-js/modules/es.typed-array.every";
import "core-js/modules/es.typed-array.fill";
import "core-js/modules/es.typed-array.filter";
import "core-js/modules/es.typed-array.find";
import "core-js/modules/es.typed-array.find-index";
import "core-js/modules/es.typed-array.for-each";
import "core-js/modules/es.typed-array.includes";
import "core-js/modules/es.typed-array.index-of";
import "core-js/modules/es.typed-array.iterator";
import "core-js/modules/es.typed-array.join";
import "core-js/modules/es.typed-array.last-index-of";
import "core-js/modules/es.typed-array.map";
import "core-js/modules/es.typed-array.reduce";
import "core-js/modules/es.typed-array.reduce-right";
import "core-js/modules/es.typed-array.reverse";
import "core-js/modules/es.typed-array.set";
import "core-js/modules/es.typed-array.slice";
import "core-js/modules/es.typed-array.some";
import "core-js/modules/es.typed-array.sort";
import "core-js/modules/es.typed-array.subarray";
import "core-js/modules/es.typed-array.to-locale-string";
import "core-js/modules/es.typed-array.to-string";
import "core-js/modules/es.weak-map";
import "core-js/modules/esnext.global-this";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

var BaseElement =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(BaseElement, _CustomElement2);

  var _super = _createSuper(BaseElement);

  function BaseElement() {
    _classCallCheck(this, BaseElement);

    return _super.apply(this, arguments);
  }

  _createClass(BaseElement, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attributeName, oldValue, newValue) {
      if (oldValue !== newValue || this[attributeName] !== newValue) {
        this[attributeName] = newValue;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.shadowRoot) {
        this.attachShadow({
          mode: 'open'
        });
      }

      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      throw new Error('Must implement render method.');
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tagName;

      try {
        window.customElements.define(tagName, this);
      } catch (e) {// noop
      }

      return this;
    }
  }, {
    key: "tagName",
    get: function get() {
      throw new Error('Must implement a default tagName.');
    }
  }]);

  return BaseElement;
}(_CustomElement);

function getCheckForSlotted(emptyClassName) {
  return function checkForSlotted() {
    // TODO: default content with dynamic descendants is unsupported
    // TODO: Use https://svelte.dev/docs#Actions + mutation observer?
    var slot = this;
    var slotted = slot.assignedNodes({
      flatten: true
    });
    var parentEl = slot.parentElement;

    if (slotted.length) {
      // TODO: temporary to ignore one known level of default content
      // Identified as "empty" by supporting style.if in template
      var hasContents = Boolean(slotted.reduce(function () {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var el = arguments.length > 1 ? arguments[1] : undefined;

        if (el.classList) {
          return result + Number(!el.classList.contains(emptyClassName));
        }

        if (el.textContent.trim().length) {
          return result + 1;
        }

        return result;
      }, 0));

      if (hasContents) {
        parentEl.classList.remove(emptyClassName);
      }
    } else {
      parentEl.classList.add(emptyClassName);
    }
  };
}

function getCheckForSlottedChildren(emptyClassName) {
  return function checkForSlotted(event) {
    // TODO: default content with dynamic descendants is unsupported
    // TODO: Use https://svelte.dev/docs#Actions + mutation observer?
    var slot = event.target;
    var slotted = slot.assignedNodes({
      flatten: true
    });
    var parentEl = this;

    if (slotted.length) {
      // TODO: temporary to ignore one known level of default content
      // Identified as "empty" by supporting style.if in template
      var hasContents = Boolean(slotted.reduce(function () {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var el = arguments.length > 1 ? arguments[1] : undefined;

        if (el.classList) {
          return result + Number(!el.classList.contains(emptyClassName));
        }

        if (el.textContent.trim().length) {
          return result + 1;
        }

        return result;
      }, 0));

      if (hasContents) {
        parentEl.classList.remove(emptyClassName);
      }
    } else {
      parentEl.classList.add(emptyClassName);
    }
  };
}

function bubbleSlotchange(event) {
  if (event.bubbles) {
    return;
  }

  var bubbleEvent = new Event('slotchange', {
    bubbles: true,
    cancelable: true
  });
  event.target.dispatchEvent(bubbleEvent);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var store = new WeakMap(); // TODO: consider improvements to dev experience for invalid registrations

function _validateStyle(_ref) {
  var attributeName = _ref.attributeName,
      attributeValue = _ref.attributeValue,
      className = _ref.className,
      parts = _ref.parts,
      styles = _ref.styles,
      variations = _ref.variations;
  return Boolean(attributeName && attributeValue && className && (!parts || parts === Object(parts)) && styles && (!variations || variations === Object(variations)));
}

function _validateStyles(styles) {
  var validateAll = function validateAll(value, style) {
    var isValid = Boolean(style) && _validateStyle(style);

    if (isValid) {
      var newValue = value + 1;
      return newValue;
    }

    return value;
  };

  return styles.length === styles.reduce(validateAll, 0);
}

function _validateAddStyles(styles) {
  if (styles && styles === Object(styles)) {
    if (Array.isArray(styles)) {
      return _validateStyles(styles);
    }

    return _validateStyle(styles);
  }

  return false;
}

function _hasParts(style) {
  return Boolean(style && Object(style.parts) === style.parts && Object.keys(style.parts).length && typeof style.parts.hasOwnProperty === 'function');
}

function _hasVariations(style) {
  return Boolean(style && Object(style.variations) === style.variations && Object.keys(style.variations).length && typeof style.variations.hasOwnProperty === 'function');
}

function _getRelatedClassNames() {
  var classNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var style = arguments.length > 1 ? arguments[1] : undefined;
  classNames.push(style.className);

  if (_hasParts(style)) {
    classNames = classNames.concat(Object.values(style.parts));
  }

  if (_hasVariations(style)) {
    classNames = classNames.concat(Object.values(style.variations));
  }

  return classNames;
}

var Styles =
/*#__PURE__*/
function () {
  function Styles() {
    var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Styles);

    store.set(this, {});
    this.addStyles(styles);
  }

  _createClass(Styles, [{
    key: "addStyle",
    value: function addStyle(_ref2) {
      var attributeName = _ref2.attributeName,
          attributeValue = _ref2.attributeValue,
          className = _ref2.className,
          parts = _ref2.parts,
          styles = _ref2.styles,
          variations = _ref2.variations;

      var style = _defineProperty({}, attributeName, _defineProperty({}, attributeValue, {
        className: className,
        parts: parts,
        styles: styles,
        variations: variations
      }));

      if (store.get(this).hasOwnProperty(attributeName)) {
        Object.assign(store.get(this)[attributeName], style[attributeName]);
      } else {
        Object.assign(store.get(this), style);
      }
    }
  }, {
    key: "addStyles",
    value: function addStyles(styles) {
      var isValid = _validateAddStyles(styles);

      if (isValid) {
        if (Array.isArray(styles)) {
          var _addStyle = this.addStyle.bind(this);

          styles.forEach(_addStyle);
        } else {
          this.addStyle(styles);
        }
      }

      return this;
    }
  }, {
    key: "findStyle",
    value: function findStyle(_ref3) {
      var attributeName = _ref3.attributeName,
          attributeValue = _ref3.attributeValue;

      var _ref4 = store.get(this) || {},
          _ref4$attributeName = _ref4[attributeName];

      _ref4$attributeName = _ref4$attributeName === void 0 ? {} : _ref4$attributeName;
      var _ref4$attributeName$a = _ref4$attributeName[attributeValue];
      _ref4$attributeName$a = _ref4$attributeName$a === void 0 ? {} : _ref4$attributeName$a;
      var className = _ref4$attributeName$a.className,
          parts = _ref4$attributeName$a.parts,
          styles = _ref4$attributeName$a.styles,
          variations = _ref4$attributeName$a.variations;
      var foundStyle = {
        attributeName: attributeName,
        attributeValue: attributeValue,
        className: className,
        parts: parts,
        styles: styles,
        variations: variations
      };
      return _validateStyle(foundStyle) ? foundStyle : false;
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      var attributes = Object.keys(store.get(this));

      if (attributes.length) {
        return attributes;
      }

      return false;
    }
  }, {
    key: "getAttributeValues",
    value: function getAttributeValues(attributeName) {
      if (store.get(this).hasOwnProperty(attributeName)) {
        return Object.keys(store.get(this)[attributeName]);
      }

      return false;
    }
  }, {
    key: "getClassName",
    value: function getClassName(_ref5) {
      var attributeName = _ref5.attributeName,
          attributeValue = _ref5.attributeValue;
      var style = this.findStyle({
        attributeName: attributeName,
        attributeValue: attributeValue
      });

      if (style.hasOwnProperty('className') && style.className !== 'ignore') {
        return style.className;
      }

      return false;
    }
  }, {
    key: "getClassNames",
    value: function getClassNames(attributeName) {
      if (store.get(this).hasOwnProperty(attributeName)) {
        return Object.values(store.get(this)[attributeName]).reduce(_getRelatedClassNames, []);
      }

      return false;
    }
  }, {
    key: "getPartClassName",
    value: function getPartClassName(_ref6) {
      var attributeName = _ref6.attributeName,
          attributeValue = _ref6.attributeValue,
          partName = _ref6.partName;
      var style = this.findStyle({
        attributeName: attributeName,
        attributeValue: attributeValue
      });

      if (_hasParts(style) && style.parts.hasOwnProperty(partName)) {
        return style.parts[partName];
      }

      return false;
    }
  }, {
    key: "getStylesheet",
    value: function getStylesheet(_ref7) {
      var attributeName = _ref7.attributeName,
          attributeValue = _ref7.attributeValue;
      var style = this.findStyle({
        attributeName: attributeName,
        attributeValue: attributeValue
      });

      if (style.hasOwnProperty('styles')) {
        return style.styles;
      }

      return false;
    }
  }, {
    key: "getVariationClassName",
    value: function getVariationClassName(_ref8) {
      var attributeName = _ref8.attributeName,
          attributeValue = _ref8.attributeValue,
          variationName = _ref8.variationName;
      var style = this.findStyle({
        attributeName: attributeName,
        attributeValue: attributeValue
      });

      if (_hasVariations(style) && style.variations.hasOwnProperty(variationName)) {
        return style.variations[variationName];
      }

      return false;
    }
  }, {
    key: "styles",
    get: function get() {
      return Object.freeze(JSON.parse(JSON.stringify(store.get(this))));
    }
  }]);

  return Styles;
}();

var InvalidCustomElementError =
/*#__PURE__*/
function () {
  function InvalidCustomElementError(_ref) {
    var defaultElements = _ref.defaultElements,
        tagName = _ref.tagName;

    _classCallCheck(this, InvalidCustomElementError);

    this.defaultElements = defaultElements;
    this.name = 'Invalid Custom Element';
    this.message = "".concat(this.name, ": ").concat(JSON.stringify(tagName), " is not a custom element in this dls package containing ").concat(this.getDefaultElsString());
  }

  _createClass(InvalidCustomElementError, [{
    key: "getDefaultElsString",
    value: function getDefaultElsString() {
      var defaultElementsArr = Object.keys(this.defaultElements);

      if (defaultElementsArr.length > 1) {
        defaultElementsArr.splice(defaultElementsArr.length - 1, 0, 'and');
      }

      return defaultElementsArr.join(' ');
    }
  }]);

  return InvalidCustomElementError;
}();

var EmptyDefaultElementsError =
/*#__PURE__*/
_createClass(function EmptyDefaultElementsError(elements) {
  _classCallCheck(this, EmptyDefaultElementsError);

  this.name = 'Empty Default Elements';
  this.message = "".concat(this.name, ": ").concat(JSON.stringify(elements), " must have at least one custom element tag name to class constructor key-value pair");
});

var ConstructorTypeError =
/*#__PURE__*/
_createClass(function ConstructorTypeError(constructorClass) {
  _classCallCheck(this, ConstructorTypeError);

  this.name = 'Invalid Constructor Type';
  this.message = "".concat(this.name, ": ").concat(JSON.stringify(constructorClass), " must be a class constructor function");
});

var DefaultElementsTypeError =
/*#__PURE__*/
_createClass(function DefaultElementsTypeError(elements) {
  _classCallCheck(this, DefaultElementsTypeError);

  this.name = 'Invalid Default Elements Type';
  this.message = "".concat(this.name, ": ").concat(JSON.stringify(elements), " must be an object containing custom element tag name to class constructor key-value pair(s)");
});

var CustomElementShapeError =
/*#__PURE__*/
_createClass(function CustomElementShapeError(element) {
  _classCallCheck(this, CustomElementShapeError);

  this.name = 'Invalid Custom Element Shape';
  this.message = "".concat(this.name, ": ").concat(JSON.stringify(element), " must be an object containing the properties tagName and constructor");
});

var CustomElementTypeError =
/*#__PURE__*/
_createClass(function CustomElementTypeError(element) {
  _classCallCheck(this, CustomElementTypeError);

  this.name = 'Invalid Custom Element Type';
  this.message = "".concat(this.name, ": ").concat(JSON.stringify(element), " must be formatted as an object");
});

var TagNameCollisionWarning =
/*#__PURE__*/
_createClass(function TagNameCollisionWarning(tagName) {
  _classCallCheck(this, TagNameCollisionWarning);

  this.name = 'Tag Name Collision';
  this.tagName = tagName;
  this.message = "".concat(this.name, ": ").concat(this.tagName, " is already defined in the Custom Element Registry");
});

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var DefineElement =
/*#__PURE__*/
function () {
  function DefineElement() {
    _classCallCheck(this, DefineElement);
  }

  _createClass(DefineElement, null, [{
    key: "define",
    value: function define(customElement) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var isValid = _validateInput(customElement);

      if (isValid) {
        return _defineElement(customElement, options);
      }
    }
  }]);

  return DefineElement;
}();

function _validateElement(element) {
  if (element && element.tagName && element.constructorClass) {
    return true;
  } else {
    throw new CustomElementShapeError(element);
  }
}

function _validateInput(element) {
  if (element && element === Object(element) && !Array.isArray(element)) {
    return _validateElement(element);
  }

  throw new CustomElementTypeError(element);
}

function _defineElement(_ref, _ref2) {
  var tagName = _ref.tagName,
      constructorClass = _ref.constructorClass;
  var makeUniqueConstructor = _ref2.makeUniqueConstructor,
      makeUniqueTagName = _ref2.makeUniqueTagName,
      uniqueTagNameSuffix = _ref2.uniqueTagNameSuffix;

  try {
    window.customElements.define(tagName, constructorClass);
    return tagName;
  } catch (error) {
    if (_isNotHandledError(error.name)) {
      throw error;
    }

    if (_isTagNameCollision(tagName)) {
      if (!makeUniqueTagName) {
        throw new TagNameCollisionWarning(tagName);
      }

      var versionedTagName = "".concat(tagName, "-").concat(uniqueTagNameSuffix);
      return _defineElement({
        tagName: versionedTagName,
        constructorClass: constructorClass
      }, {
        makeUniqueConstructor: makeUniqueConstructor
      });
    }

    if (_isConstructorCollision({
      makeUniqueConstructor: makeUniqueConstructor,
      tagName: tagName
    })) {
      var extendedElement = _extendElement(constructorClass);

      return _defineElement({
        tagName: tagName,
        constructorClass: extendedElement
      }, {
        makeUniqueTagName: makeUniqueTagName
      });
    }

    throw error;
  }
}

function _isNotHandledError(errorName) {
  return errorName !== 'NotSupportedError';
}

function _isTagNameCollision(tagName) {
  return !!window.customElements.get(tagName);
} // There is no way to confirm if the constructor already exists so
// _isConstructorCollision assumes the absence of a tag name collision
// means the element definition failed from a constructor collision


function _isConstructorCollision(_ref3) {
  var makeUniqueConstructor = _ref3.makeUniqueConstructor,
      tagName = _ref3.tagName;
  return !_isTagNameCollision(tagName) && makeUniqueConstructor;
}

function _extendElement(ElementConstructor) {
  return (
    /*#__PURE__*/
    function (_ElementConstructor) {
      _inherits(ExtendedConstructor, _ElementConstructor);

      var _super = _createSuper$1(ExtendedConstructor);

      function ExtendedConstructor() {
        _classCallCheck(this, ExtendedConstructor);

        return _super.apply(this, arguments);
      }

      return _createClass(ExtendedConstructor);
    }(ElementConstructor)
  );
}

var define = DefineElement.define;
var DEFAULT_UNIQUE_TAG_NAME_SUFFIX = 'default-tag-name-suffix';

function _isValidShape(elements) {
  if (Object.entries(elements).length === 0) {
    throw new EmptyDefaultElementsError(elements);
  }

  Object.values(elements).forEach(function (constructorClass) {
    if (typeof constructorClass !== 'function') {
      throw new ConstructorTypeError(constructorClass);
    }
  });
  return true;
}

function _isValidType(elements) {
  if (elements && elements === Object(elements) && !Array.isArray(elements)) {
    return true;
  }

  throw new DefaultElementsTypeError(elements);
}

function _isValidInput(elements) {
  if (_isValidType(elements) && _isValidShape(elements)) {
    return true;
  }

  return false;
}

function _isIncludedInDefaults(consumerSpecifiedElements, defaultElements) {
  Object.keys(consumerSpecifiedElements).forEach(function (tagName) {
    if (defaultElements[tagName] === undefined) {
      throw new InvalidCustomElementError({
        defaultElements: defaultElements,
        tagName: tagName
      });
    }
  });
  return true;
}

function getElementsToDefine(_ref) {
  var consumerSpecifiedElements = _ref.consumerSpecifiedElements,
      defaultElements = _ref.defaultElements;

  if (consumerSpecifiedElements && _isIncludedInDefaults(consumerSpecifiedElements, defaultElements)) {
    return consumerSpecifiedElements;
  }

  return defaultElements;
}

function getTagNameSuffix(options) {
  return options.uniqueTagNameSuffix.length === 0 ? DEFAULT_UNIQUE_TAG_NAME_SUFFIX : options.uniqueTagNameSuffix;
}

function defineWithDefaults(defaultElements) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    uniqueTagNameSuffix: DEFAULT_UNIQUE_TAG_NAME_SUFFIX
  };

  if (_isValidInput(defaultElements)) {
    return function (consumerSpecifiedElements) {
      // if the consumer supplies a specific set of elements to define,
      // it will override the original set of defaultElements
      var elementsToDefine = getElementsToDefine({
        consumerSpecifiedElements: consumerSpecifiedElements,
        defaultElements: defaultElements
      });
      var definedTagNames = new Map();
      Object.keys(elementsToDefine).forEach(function (tagName) {
        var _elementsToDefine$tag = elementsToDefine[tagName],
            _elementsToDefine$tag2 = _elementsToDefine$tag.makeUniqueConstructor,
            makeUniqueConstructor = _elementsToDefine$tag2 === void 0 ? false : _elementsToDefine$tag2,
            _elementsToDefine$tag3 = _elementsToDefine$tag.makeUniqueTagName,
            makeUniqueTagName = _elementsToDefine$tag3 === void 0 ? false : _elementsToDefine$tag3;
        var definedTagName;

        try {
          definedTagName = define({
            tagName: tagName,
            constructorClass: defaultElements[tagName]
          }, {
            makeUniqueConstructor: makeUniqueConstructor,
            makeUniqueTagName: makeUniqueTagName,
            uniqueTagNameSuffix: getTagNameSuffix(options)
          });
        } catch (error) {
          if (error instanceof TagNameCollisionWarning) {
            definedTagName = error.tagName; // eslint-disable-next-line no-console

            console.warn(error.message);
          } else {
            throw error;
          }
        } finally {
          definedTagNames.set(tagName, definedTagName);
        }
      });
      return definedTagNames;
    };
  }
}

var store$1 = new WeakMap();

var Styles$1 =
/*#__PURE__*/
function () {
  function Styles() {
    _classCallCheck(this, Styles);
  }

  _createClass(Styles, [{
    key: "addStyle",
    value: function addStyle(_ref) {
      var attributeName = _ref.attributeName,
          attributeValue = _ref.attributeValue,
          className = _ref.className,
          parts = _ref.parts,
          styles = _ref.styles,
          variations = _ref.variations;

      var style = _defineProperty({}, attributeName, _defineProperty({}, attributeValue, {
        className: className,
        parts: parts,
        styles: styles,
        variations: variations
      }));

      if (this.hasOwnProperty(attributeName)) {
        Object.assign(this[attributeName], style[attributeName]);
      } else {
        Object.assign(this, style);
      }
    }
  }]);

  return Styles;
}();

function _canUseRegisteredConstructor(elementConstructor) {
  return Boolean(elementConstructor.tagName && (typeof customElements === "undefined" ? "undefined" : _typeof(customElements)) === 'object' && typeof customElements.get === 'function');
}

function _getRegisteredConstructor(elementConstructor) {
  if (_canUseRegisteredConstructor(elementConstructor)) {
    var registeredConstructor = customElements.get(elementConstructor.tagName);

    if (registeredConstructor) {
      return registeredConstructor;
    }
  }

  return elementConstructor;
} // TODO: consider improvements to dev experience for invalid registrations


function _validateStyle$1(_ref2) {
  var attributeName = _ref2.attributeName,
      attributeValue = _ref2.attributeValue,
      className = _ref2.className,
      parts = _ref2.parts,
      styles = _ref2.styles,
      variations = _ref2.variations;
  return Boolean(attributeName && attributeValue && className && (!parts || parts === Object(parts)) && styles && (!variations || variations === Object(variations)));
}

function _validateStyles$1(styles) {
  var validateAll = function validateAll(value, style) {
    var isValid = Boolean(style) && _validateStyle$1(style);

    if (isValid) {
      var newValue = value + 1;
      return newValue;
    }

    return value;
  };

  return styles.length === styles.reduce(validateAll, 0);
}

function _validateAddStyles$1(styles) {
  if (styles && styles === Object(styles)) {
    if (Array.isArray(styles)) {
      return _validateStyles$1(styles);
    }

    return _validateStyle$1(styles);
  }

  return false;
}

function _optionallyInitStyles(elementConstructor) {
  if (store$1.has(elementConstructor) && store$1.get(elementConstructor) instanceof Styles$1) {
    return;
  }

  store$1.set(elementConstructor, new Styles$1());
}

function _addStyle(elementConstructor, _ref3) {
  var attributeName = _ref3.attributeName,
      attributeValue = _ref3.attributeValue,
      className = _ref3.className,
      parts = _ref3.parts,
      styles = _ref3.styles,
      variations = _ref3.variations;
  store$1.get(elementConstructor).addStyle({
    attributeName: attributeName,
    attributeValue: attributeValue,
    className: className,
    parts: parts,
    styles: styles,
    variations: variations
  });
}

function _addStyles(elementConstructor, styles) {
  var addStyle = _addStyle.bind(null, elementConstructor);

  styles.forEach(addStyle);
}

function _add(elementConstructor, styles) {
  _optionallyInitStyles(elementConstructor);

  if (Array.isArray(styles)) {
    return _addStyles(elementConstructor, styles);
  }

  return _addStyle(elementConstructor, styles);
}

function _hasParts$1(style) {
  return Boolean(style && Object(style.parts) === style.parts && Object.keys(style.parts).length);
}

function _hasVariations$1(style) {
  return Boolean(style && Object(style.variations) === style.variations && Object.keys(style.variations).length);
}

function _getRelatedClassNames$1() {
  var classNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var style = arguments.length > 1 ? arguments[1] : undefined;
  classNames.push(style.className);

  if (_hasParts$1(style)) {
    classNames = classNames.concat(Object.values(style.parts));
  }

  if (_hasVariations$1(style)) {
    classNames = classNames.concat(Object.values(style.variations));
  }

  return classNames;
}

var RegisterStyles =
/*#__PURE__*/
function () {
  function RegisterStyles() {
    _classCallCheck(this, RegisterStyles);
  }

  _createClass(RegisterStyles, null, [{
    key: "add",
    value: function add(elementConstructor, styles) {
      var isValid = _validateAddStyles$1(styles);

      if (isValid) {
        var registeredConstructor = _getRegisteredConstructor(elementConstructor);

        _add(registeredConstructor, styles);
      }
    }
  }, {
    key: "find",
    value: function find(elementConstructor, _ref4) {
      var attributeName = _ref4.attributeName,
          attributeValue = _ref4.attributeValue;

      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      var _ref5 = store$1.get(registeredConstructor) || {},
          _ref5$attributeName = _ref5[attributeName];

      _ref5$attributeName = _ref5$attributeName === void 0 ? {} : _ref5$attributeName;
      var _ref5$attributeName$a = _ref5$attributeName[attributeValue];
      _ref5$attributeName$a = _ref5$attributeName$a === void 0 ? {} : _ref5$attributeName$a;
      var className = _ref5$attributeName$a.className,
          parts = _ref5$attributeName$a.parts,
          styles = _ref5$attributeName$a.styles,
          variations = _ref5$attributeName$a.variations;
      var foundStyle = {
        attributeName: attributeName,
        attributeValue: attributeValue,
        className: className,
        parts: parts,
        styles: styles,
        variations: variations
      };
      return _validateStyle$1(foundStyle) ? foundStyle : false;
    }
  }, {
    key: "get",
    value: function get(elementConstructor) {
      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      _optionallyInitStyles(registeredConstructor);

      return Object.freeze(JSON.parse(JSON.stringify(store$1.get(registeredConstructor))));
    }
  }, {
    key: "getAttributes",
    value: function getAttributes(elementConstructor) {
      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      if (store$1.has(registeredConstructor)) {
        return Object.keys(store$1.get(registeredConstructor));
      }

      return false;
    }
  }, {
    key: "getAttributeValues",
    value: function getAttributeValues(elementConstructor, attributeName) {
      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      if (store$1.has(registeredConstructor)) {
        var options = store$1.get(registeredConstructor);

        if (options.hasOwnProperty(attributeName)) {
          return Object.keys(options[attributeName]);
        }
      }

      return false;
    }
  }, {
    key: "getClassNames",
    value: function getClassNames(elementConstructor, attributeName) {
      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      if (store$1.has(registeredConstructor)) {
        var options = store$1.get(registeredConstructor);

        if (options.hasOwnProperty(attributeName)) {
          return Object.values(options[attributeName]).reduce(_getRelatedClassNames$1, []);
        }
      }

      return false;
    }
  }, {
    key: "getPartClassName",
    value: function getPartClassName(elementConstructor, _ref6) {
      var attributeName = _ref6.attributeName,
          attributeValue = _ref6.attributeValue,
          partName = _ref6.partName;

      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      var style = RegisterStyles.find(registeredConstructor, {
        attributeName: attributeName,
        attributeValue: attributeValue
      });

      if (_hasParts$1(style) && style.parts.hasOwnProperty(partName)) {
        return style.parts[partName];
      }

      return false;
    }
  }, {
    key: "getVariationClassName",
    value: function getVariationClassName(elementConstructor, _ref7) {
      var attributeName = _ref7.attributeName,
          attributeValue = _ref7.attributeValue,
          variationName = _ref7.variationName;

      var registeredConstructor = _getRegisteredConstructor(elementConstructor);

      var style = RegisterStyles.find(registeredConstructor, {
        attributeName: attributeName,
        attributeValue: attributeValue
      });

      if (_hasVariations$1(style) && style.variations.hasOwnProperty(variationName)) {
        return style.variations[variationName];
      }

      return false;
    }
  }]);

  return RegisterStyles;
}();

var add = RegisterStyles.add,
    find = RegisterStyles.find,
    get = RegisterStyles.get,
    getAttributes = RegisterStyles.getAttributes,
    getAttributeValues = RegisterStyles.getAttributeValues,
    getClassNames = RegisterStyles.getClassNames,
    getPartClassName = RegisterStyles.getPartClassName,
    getVariationClassName = RegisterStyles.getVariationClassName;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var STYLE_SELECTOR = 'style[id]';

function _getNodes(string) {
  return document.createRange().createContextualFragment(string);
}

function _getCurrentStyles(shadowRoot) {
  // eslint-disable-next-line prefer-reflect
  var styles = Array.prototype.slice.call(shadowRoot.querySelectorAll(STYLE_SELECTOR));
  return styles.map(function (el) {
    return el.id;
  });
}

function _renderStyle(shadowRoot, currentStyles, _ref) {
  var attributeName = _ref.attributeName,
      attributeValue = _ref.attributeValue,
      styles = _ref.styles;
  var id = "styles-".concat(attributeName, "-").concat(attributeValue);

  if (currentStyles.indexOf(id) === -1) {
    shadowRoot.appendChild(_getNodes("<style id=\"".concat(id, "\">").concat(styles, "</style>")));
  }
}

function _renderStyles(shadowRoot, allStyles) {
  var currentStyles = _getCurrentStyles(shadowRoot);

  Object.entries(allStyles).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        attributeName = _ref3[0],
        allAttributeValues = _ref3[1];

    Object.entries(allAttributeValues).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          attributeValue = _ref5[0],
          styles = _ref5[1].styles;

      _renderStyle(shadowRoot, currentStyles, {
        attributeName: attributeName,
        attributeValue: attributeValue,
        styles: styles
      });
    });
  });
}

var StyledElement =
/*#__PURE__*/
function (_BaseElement) {
  _inherits(StyledElement, _BaseElement);

  var _super = _createSuper$2(StyledElement);

  function StyledElement() {
    _classCallCheck(this, StyledElement);

    return _super.apply(this, arguments);
  }

  _createClass(StyledElement, [{
    key: "registerStyles",
    value: function registerStyles(styles) {
      return this.constructor.registerStyles(styles);
    }
  }, {
    key: "renderStyles",
    value: function renderStyles() {
      _renderStyles(this.shadowRoot, get(this.constructor));
    }
  }, {
    key: "styles",
    get: function get$1() {
      return get(this.constructor);
    }
  }], [{
    key: "registerStyles",
    value: function registerStyles(styles) {
      add(this, styles);
      return this;
    }
  }, {
    key: "styles",
    get: function get$1() {
      return get(this);
    }
  }]);

  return StyledElement;
}(BaseElement);

function _parseShortcut(shortcut, validLength) {
  if (typeof shortcut === 'string') {
    var parsedShortcut = shortcut.split('/');

    if (parsedShortcut.length === validLength) {
      return parsedShortcut;
    }

    throw new Error("Shortcut ".concat(shortcut, " is an invalid length."));
  }

  throw new Error("Shortcut ".concat(shortcut, " is an invalid type."));
} // part('theme/whatever/whatever')


function part(shortcut) {
  var _parseShortcut2 = _parseShortcut(shortcut, 3),
      _parseShortcut3 = _slicedToArray(_parseShortcut2, 3),
      attributeName = _parseShortcut3[0],
      attributeValue = _parseShortcut3[1],
      partName = _parseShortcut3[2];

  return {
    attributeName: attributeName,
    attributeValue: attributeValue,
    partName: partName
  };
} // style('theme/whatever')


function style(shortcut) {
  var _parseShortcut4 = _parseShortcut(shortcut, 2),
      _parseShortcut5 = _slicedToArray(_parseShortcut4, 2),
      attributeName = _parseShortcut5[0],
      attributeValue = _parseShortcut5[1];

  return {
    attributeName: attributeName,
    attributeValue: attributeValue
  };
} // variant('theme/whatever/whatever')


function variant(shortcut) {
  var _parseShortcut6 = _parseShortcut(shortcut, 3),
      _parseShortcut7 = _slicedToArray(_parseShortcut6, 3),
      attributeName = _parseShortcut7[0],
      attributeValue = _parseShortcut7[1],
      variationName = _parseShortcut7[2];

  return {
    attributeName: attributeName,
    attributeValue: attributeValue,
    variationName: variationName
  };
}

function _CustomElement$1() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement$1.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement$1, HTMLElement);

function noop() {}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

var subscriber_queue = [];
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */

function writable(value) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var stop;
  var subscribers = [];

  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;

      if (stop) {
        // store is ready
        var run_queue = !subscriber_queue.length;

        for (var i = 0; i < subscribers.length; i += 1) {
          var s = subscribers[i];
          s[1]();
          subscriber_queue.push(s, value);
        }

        if (run_queue) {
          for (var _i = 0; _i < subscriber_queue.length; _i += 2) {
            subscriber_queue[_i][0](subscriber_queue[_i + 1]);
          }

          subscriber_queue.length = 0;
        }
      }
    }
  }

  function update(fn) {
    set(fn(value));
  }

  function subscribe(run) {
    var invalidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    var subscriber = [run, invalidate];
    subscribers.push(subscriber);

    if (subscribers.length === 1) {
      stop = start(set) || noop;
    }

    run(value);
    return function () {
      var index = subscribers.indexOf(subscriber);

      if (index !== -1) {
        subscribers.splice(index, 1);
      }

      if (subscribers.length === 0) {
        stop();
        stop = null;
      }
    };
  }

  return {
    set: set,
    update: update,
    subscribe: subscribe
  };
}

function createStyleStore() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var componentStyles = new Styles(styles);
  var hoistedStylesheets = {};

  componentStyles.part = function (shortcut) {
    var partName = componentStyles.getPartClassName(part(shortcut));
    return partName ? partName : '';
  };

  componentStyles.sheet = function (shortcut) {
    var rules = componentStyles.getStylesheet(style(shortcut));
    return rules ? "<style id=\"".concat(shortcut, "\">").concat(rules, "</style>") : '';
  };

  componentStyles.style = function (shortcut) {
    var className = componentStyles.getClassName(style(shortcut));
    return className ? className : '';
  };

  componentStyles.variant = function (shortcut) {
    var variationName = componentStyles.getVariationClassName(variant(shortcut));
    return variationName ? variationName : '';
  };

  var store = writable(componentStyles);
  var subscribe = store.subscribe,
      set = store.set;
  return {
    subscribe: subscribe,
    addStyles: function addStyles(styles) {
      componentStyles.addStyles(styles);
      set(componentStyles);
    },
    isNewStylesheet: function isNewStylesheet(id) {
      if (hoistedStylesheets[id]) {
        return false;
      }

      hoistedStylesheets[id] = true;
      return true;
    }
  };
}

var store$2 = new WeakMap();

var _usesPolyfill = Boolean(!('attachShadow' in Element.prototype && 'getRootNode' in Element.prototype) || window.ShadyDOM);

var StyleUtilities =
/*#__PURE__*/
function () {
  function StyleUtilities() {
    var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, StyleUtilities);

    if (Object(styles) !== styles) {
      styles = {};
    }

    store$2.set(this, styles);
  }

  _createClass(StyleUtilities, [{
    key: "_getBooleanClassName",
    value: function _getBooleanClassName(className, isTrue) {
      if (isTrue) {
        return this._getScopedClassName(className);
      }

      return '';
    }
  }, {
    key: "_getBooleanAlternatingClassName",
    value: function _getBooleanAlternatingClassName(onClassName, offClassName, isTrue) {
      onClassName = this._getScopedClassName(onClassName);
      offClassName = this._getScopedClassName(offClassName);

      if (isTrue) {
        return onClassName;
      }

      return offClassName;
    }
  }, {
    key: "_getScopedClassName",
    value: function _getScopedClassName(officialClassName) {
      var styles = store$2.get(this);

      if (styles && this._isClassName(officialClassName)) {
        var scopedClassName = styles[officialClassName];

        if (this._isClassName(scopedClassName)) {
          return scopedClassName;
        }
      }

      return '';
    }
  }, {
    key: "_getEnumeratedClassName",
    value: function _getEnumeratedClassName(className, optionalDefaultClassName) {
      className = this._getScopedClassName(className);
      optionalDefaultClassName = this._getScopedClassName(optionalDefaultClassName);

      if (this._isClassName(className)) {
        return className;
      } else if (this._isClassName(optionalDefaultClassName)) {
        return optionalDefaultClassName;
      }

      return '';
    }
  }, {
    key: "_isClassName",
    value: function _isClassName(className) {
      return Boolean(className && typeof className === 'string' && className.length);
    }
  }, {
    key: "usesPolyfill",
    get: function get() {
      return _usesPolyfill;
    }
  }, {
    key: 'if',
    value: function _if(className, isTrue) {
      return this._getBooleanClassName(className, isTrue);
    }
  }, {
    key: 'is',
    value: function is(className, optionalDefaultClassName) {
      return this._getEnumeratedClassName(className, optionalDefaultClassName);
    }
  }, {
    key: 'or',
    value: function or(onClassName, offClassName, isTrue) {
      return this._getBooleanAlternatingClassName(onClassName, offClassName, isTrue);
    }
  }, {
    key: 'are',
    value: function are() {
      var _this = this;

      for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
        classNames[_key] = arguments[_key];
      }

      return classNames.map(function (className) {
        return _this._getScopedClassName(className);
      }).filter(function (className) {
        return className.length;
      }).join(' ');
    }
  }]);

  return StyleUtilities;
}();

function _formatClassNames(classNames) {
  classNames = Array.isArray(classNames) ? classNames : [classNames];
  var formattedClassNames = [];
  classNames.forEach(function (className) {
    if (typeof className === 'string') {
      className.trim().split(' ').forEach(function (splitClassName) {
        formattedClassNames.push(splitClassName);
      });
    }
  });
  return formattedClassNames;
}

function _removeClassName(classList, classNamesToKeep, className) {
  if (!classNamesToKeep || classNamesToKeep.indexOf(className) === -1) {
    classList.remove(className);
  }
}

function _removeClassNames(classList, classNamesToRemove) {
  var classNamesToKeep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var removeClassName = _removeClassName.bind(null, classList, classNamesToKeep);

  classNamesToRemove.forEach(removeClassName);
}

function _addClassName(classList, className) {
  if (!classList.contains(className)) {
    classList.add(className);
  }
}

function _addClassNames(classList, classNamesToAdd) {
  var addNewClassName = _addClassName.bind(null, classList);

  classNamesToAdd.forEach(addNewClassName);
} // TODO: remove?
// function _updateBooleanStyles(element, classNamesToRemove, classNamesToAdd) {
//   classNamesToAdd = Array.isArray(classNamesToAdd) ? classNamesToAdd : [ classNamesToAdd ];
//   _removeClassNames(element.classList, classNamesToRemove);
//   _addClassNames(element.classList, classNamesToAdd);
// }


function _updateEnumStyles(element, classNamesToRemove, classNamesToAdd) {
  if (classNamesToRemove) {
    classNamesToRemove = _formatClassNames(classNamesToRemove);

    _removeClassNames(element.classList, classNamesToRemove, classNamesToAdd);
  }

  if (classNamesToAdd) {
    classNamesToAdd = _formatClassNames(classNamesToAdd);

    _addClassNames(element.classList, classNamesToAdd);
  }
}

var UpdateStyles =
/*#__PURE__*/
function () {
  function UpdateStyles() {
    _classCallCheck(this, UpdateStyles);
  }

  _createClass(UpdateStyles, null, [{
    key: "update",
    value: function update(element, classNamesToRemove, classNamesToAdd) {
      _updateEnumStyles(element, classNamesToRemove, classNamesToAdd);
    }
  }]);

  return UpdateStyles;
}();

var update = UpdateStyles.update;
export { BaseElement, Styles as ComponentStyles, RegisterStyles, StyleUtilities, StyledElement, createStyleStore as SvelteStyleStoreFactory, UpdateStyles, add, bubbleSlotchange, defineWithDefaults, find, get, getAttributeValues, getAttributes, getCheckForSlotted, getCheckForSlottedChildren, getClassNames, getPartClassName, getVariationClassName, update };